import { render, staticRenderFns } from "./menu-section-list-v2.vue?vue&type=template&id=7b227511&scoped=true"
import script from "./menu-section-list-v2.vue?vue&type=script&lang=ts"
export * from "./menu-section-list-v2.vue?vue&type=script&lang=ts"
import style0 from "./menu-section-list-v2.vue?vue&type=style&index=0&id=7b227511&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b227511",
  null
  
)

export default component.exports